var infFeaturesLg = tns({
	"container": ".slider-infFeaturesLg",
	"controlsContainer": ".slider-infFeaturesLg-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"navPosition": "bottom",
	"gutter": 24,
	"slideBy": "page",
	"responsive": {
		"768": {
			"items": 2
		},
		"992": {
			"items": 1,
			"gutter": 32
		},
		"1280": {
			"items": 2
		}
	}
});
// Modul to create slide counter on mobile - REQUIRED
avm.require('avast.web.slideCounter')(infFeaturesLg);

var infFeaturesPc = tns({
		"container": ".slider-infFeatures-pc",
		"controlsContainer": ".slider-infFeatures-pc-controls",
		"preventScrollOnTouch": "force",
		"controlsPosition": "bottom",
		"navPosition": "bottom",
		"gutter": 24,
		"slideBy": "page",
		"responsive": {
			"768": {
				"items": 2
			},
			"992": {
				"items": 1,
				"gutter": 32
			},
			"1280": {
				"items": 2
			}
		}
	});
	// Create a slide counter bellow the Carousel
	avm.require('avast.web.slideCounter')(infFeaturesPc);


	var infFeaturesMac = tns({
		"container": ".slider-infFeatures-mac",
		"controlsContainer": ".slider-infFeatures-mac-controls",
		"preventScrollOnTouch": "force",
		"controlsPosition": "bottom",
		"navPosition": "bottom",
		"gutter": 24,
		"slideBy": "page",
		"responsive": {
			"768": {
				"items": 2
			},
			"992": {
				"items": 1,
				"gutter": 32
			},
			"1280": {
				"items": 2
			}
		}
	});
	// Create a slide counter bellow the Carousel
	avm.require('avast.web.slideCounter')(infFeaturesMac);


	var infFeaturesAndroid = tns({
		"container": ".slider-infFeatures-android",
		"controlsContainer": ".slider-infFeatures-android-controls",
		"preventScrollOnTouch": "force",
		"controlsPosition": "bottom",
		"navPosition": "bottom",
		"gutter": 24,
		"slideBy": "page",
		"responsive": {
			"768": {
				"items": 2
			},
			"992": {
				"items": 1,
				"gutter": 32
			},
			"1280": {
				"items": 2
			}
		}
	});
	// Create a slide counter bellow the Carousel
	avm.require('avast.web.slideCounter')(infFeaturesAndroid);
